module.exports = __webpack_public_path__ + "img/three-dots.aa0db2e1.svg";